module.exports = __webpack_public_path__ + "static/media/fancy_pink.75c4a1fa.jpg";